/**
 * Calculates the map URL address for a given search term.
 * Returns a Google Maps or Apple Maps URL
 * Google Maps docs: https://developers.google.com/maps/documentation/urls/
 * Apple Maps docs: https://developer.apple.com/library/archive/featuredarticles/iPhoneURLScheme_Reference/MapLinks/MapLinks.html
 */
export function getMapUrl(searchTerm: string) {
  const userAgent = window.navigator.userAgent || 'unknown';
  const isIOSDevice = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(userAgent);

  const urlBase = isIOSDevice
    ? 'https://maps.apple.com/?q='
    : 'https://www.google.com/maps/search/?api=1&query=';

  return urlBase + searchTerm;
}
